import { cn } from "@flare/ui";

export function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-blue-20", className)}
      {...props}
    />
  );
}
